import { RootState } from "../../store";
import { ResourceExplorerInterface } from "../utils/types/resourceExplorer";

export const resourceExplorerStateSelector = (
  state: RootState,
): ResourceExplorerInterface => {
  return state.resourceExplorer;
};
